import React from 'react';
import { Box } from '@mui/material';
import { BarChart, Bar, XAxis, CartesianGrid, ResponsiveContainer } from 'recharts';

const WeeklyBarChart = () => {
  const data = [
    { day: 'Su', value: 65 },
    { day: 'Mo', value: 90 },
    { day: 'Tu', value: 55 },
    { day: 'We', value: 78 },
    { day: 'Te', value: 45 },
    { day: 'Fr', value: 25 },
    { day: 'Sa', value: 35 }
  ];

  return (
    <Box sx={{ height: 200, mt: 3 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 10 }}>
          <defs>
            <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#FF1493" />
              <stop offset="100%" stopColor="#8E2DE2" />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E0E0E0" />
          <XAxis 
            dataKey="day" 
            axisLine={false} 
            tickLine={false} 
            tick={{ fill: '#999', fontSize: 12 }}
            dy={10}
          />
          <Bar 
            dataKey="value" 
            fill="url(#barGradient)" 
            radius={[4, 4, 0, 0]} 
            barSize={30}
          />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default WeeklyBarChart; 